import { ENABLE_MOCKING } from '@/config';

export const enableMocking = async () => {
  if (!import.meta.env.DEV || !ENABLE_MOCKING) {
    return;
  }

  const { worker } = await import('./mocks');

  await worker.start();
};
